<template>
    <el-dialog
        class="edit"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Edit"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form ref="editForm" :model="editForm" @keydown.enter.native.prevent>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="Username"
                            prop="username"
                            size="small"
                        >
                            <el-input
                                clearable
                                size="small"
                                v-model="editForm.username"
                                placeholder="Username"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Email" prop="email" size="small">
                            <el-input
                                clearable
                                size="small"
                                v-model="editForm.email"
                                placeholder="Email"
                                readonly
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Mobile" prop="mobile" size="small">
                            <el-input
                                clearable
                                size="small"
                                v-model="editForm.mobile"
                                placeholder="Mobile"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            label="Delivery Tag"
                            prop="need_tag"
                            size="small"
                        >
                            <el-input
                                clearable
                                size="small"
                                v-model="editForm.need_tag"
                                placeholder="Need Tag"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Role" prop="role" size="small">
                            <el-select
                                v-model="editForm.role"
                                placeholder="Please Select"
                                @change="changeRole"
                            >
                                <el-option
                                    v-for="item in roleList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Contact Email" prop="contact_email" size="small" v-if="[5,99].includes(editForm.role)">
                            <el-input
                                clearable
                                size="small"
                                v-model="editForm.contact_email"
                                placeholder="Contact Email"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Status" size="small" prop="status">
                            <el-radio-group v-model="editForm.status">
                                <el-radio :label="1">Valid</el-radio>
                                <el-radio :label="2">Invalid</el-radio>
                                <el-radio :label="3">Pending</el-radio>
                                <el-radio :label="4">Close</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                            <el-form-item
                                label="Category"
                                :rules="[
                                    {
                                        required: false,
                                        message: 'Please input Category',
                                    },
                                ]"
                                prop="category"
                                size="small"
                            >
                                <!-- <el-input
                                    clearable
                                    size="small"
                                    v-model="addForm.category"
                                    placeholder="Please input Category"
                                ></el-input> -->
                                <el-cascader
                                    filterable
                                    clearable
                                    :options="treeData"
                                    :props="cascaderProps"
                                    v-model="editForm.category"
                                    style="width: 100%"
                                    placeholder="Plaese Select Category"
                                    size="small"
                                    :show-all-levels="false"
                                >
                                </el-cascader>
                            </el-form-item>
                        </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >Save</el-button
            >
            <el-button size="small" @click="editVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapActions } from "vuex";
export default {
    data() {
        return {
            editForm: {
                username: "",
                email: "",
                mobile: "",
                need_tag: "",
                role:"",
                contact_email: "",
                status: "",
                category:[]
            },
            roleList: [],
            treeData:[],
        };
    },
    methods: {
        ...mapActions(["getRoleSelect"]),
        saleUserList() {
            cmofferApi
                .saleUserList({}, "get", this.tableItem.id)
                .then((res) => {
                    if (res) {
                        console.log(res);
                    }
                });
        },
        save() {
            this.loading = true;
            cmofferApi
                .saleUserList(
                    {
                        ...this.editForm,
                    },
                    "post",
                    this.tableItem.id
                )
                .then((res) => {
                    this.loading = false;
                    this.$message.success(
                        this.$i18n.locale == "zh" ? "成功" : "Success"
                    );
                    this.closeDialog();
                    this.$parent[this.funcName]();
                });
        },
        closeDialog() {
            this.$refs["editForm"].clearValidate();
            this.$refs["editForm"].resetFields();
            this.$emit("update:editVisible", false);
        },
        // 分类树
        goodsCategory() {
            cmofferApi.goodsCategory({}, "get").then((res) => {
                if (res) {
                    this.treeData = res.data;
                    console.log(this.treeData)
                }
            });
        },
        changeRole(){
            if(this.editForm.role != 5){
                this.editForm.contact_email = "";
            }
        },
        async initialize() {
            this.saleUserList();
        },
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
        funcName: String,
        cascaderProps: {
            type: () => Object,
            default: {
                value: "id",
                label: "name_en",
                children: "cat_id",
                checkStrictly: true,
                multiple: true,
            },
        },
    },
    watch: {
        editVisible() {
            if (this.editVisible) {
                this.editForm = {
                    ...this.tableItem,
                    status: this.tableItem.status.id,
                };
                cmofferApi.roleSelect({contain_ad:1}, "get").then((res) => {
                    this.roleList = res.data;
                });
                cmofferApi.goodsCategory({}, "get").then((res) => {
                    if (res) {
                        this.treeData = res.data;
                        console.log(this.treeData)
                    }
                });                   
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.edit {
    ::v-deep .container {
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }
        .el-select {
            width: 100%;
        }
        .el-form-item--small {
            margin-bottom: 5px !important;
        }
        .el-checkbox__label {
            font-size: 12px;
        }
        .el-radio-group {
            width: 100%;
        }
    }
}
</style>
